var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEtcServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 110,
    viewBox: "0 0 120 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.1133,
    y: 50.8057,
    width: 68.6908,
    height: 27.4763,
    transform: "rotate(-45.5529 20.1133 50.8057)",
    fill: "#3A7EFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0781,
    y: 48.7344,
    width: 10.9905,
    height: 32.9716,
    rx: 1,
    transform: "rotate(-45.5529 18.0781 48.7344)",
    fill: "#87B1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4414,
    y: 7.69043,
    width: 10.9905,
    height: 32.9716,
    rx: 1,
    transform: "rotate(-45.5529 58.4414 7.69043)",
    fill: "#87B1FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5547,
    y: 46.9492,
    width: 13.7382,
    height: 76.9337,
    rx: 2.5,
    transform: "rotate(-45.5529 55.5547 46.9492)",
    fill: "#3A7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91745 92.5296C1.97308 92.0226 2.40141 91.6387 2.91149 91.6387H55.5294C56.0395 91.6387 56.4678 92.0226 56.5235 92.5296L58.3192 108.897C58.3842 109.489 57.9207 110.006 57.3252 110.006H1.11572C0.52026 110.006 0.0567411 109.489 0.121684 108.897L1.91745 92.5296Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEtcServiceMain);
export default __webpack_public_path__ + "static/media/IcEtcServiceMain.d584ea38d92c68f5d1d83f25458dc7dd.svg";
export { ForwardRef as ReactComponent };